import Pusher from 'pusher-js';
import { bindPusherConnectionTelemetry } from '@shared/utils/bindPusherConnectionTelemetry.js';
import { privateMessageEvent } from '@/schema/privateMessageEvent';
import getPlatformApiBaseUrl from './getPlatformApiBaseUrl';
import { getToken } from './authHelper';
import { action } from './api';
import { reportPusherConnectionLifecycle } from './pusher/reportPusherConnectionLifecycle';
import getPusherAuthHeaders from './pusher/getPusherAuthHeaders.js';

const PUSHER_KEY = 'fffdb90f57c031f5ab51';
const PUSHER_CLUSTER = 'us3';

const getClient = async () => {
  const BASE_API = getPlatformApiBaseUrl({ trailingSlash: false });
  const bearerToken = (await window?.Clerk?.session?.getToken()) || getToken();

  const pusher = new Pusher(PUSHER_KEY, {
    cluster: PUSHER_CLUSTER,
    forceTLS: true,
    channelAuthorization: {
      endpoint: `${BASE_API}/v1/auth/pusher`,
      transport: 'ajax',
      headersProvider: () => getPusherAuthHeaders(bearerToken)
    }
  });

  bindPusherConnectionTelemetry({
    connection: pusher.connection,
    emit: async (event) => {
      const currentBearerToken = (await window?.Clerk?.session?.getToken()) || getToken();
      reportPusherConnectionLifecycle({ baseApi: BASE_API, bearerToken: currentBearerToken || bearerToken, event });
    }
  });

  return {
    subscribe: (channelName, next) => {
      const channel = pusher.subscribe(channelName);

      return channel.bind(privateMessageEvent, (data) => {
        next(data);
      });
    },

    subscribeToPresence: (channelName) => {
      const channel = pusher.subscribe(channelName);

      channel.bind('pusher:subscription_succeeded', (members) => {
        const initialMembers = {};
        members.each((member) => {
          initialMembers[member.id] = { ...member.info, isCurrentUser: members?.me?.id === member?.id };
        });
        action('SET_MEMBERS', initialMembers);
      });

      channel.bind('pusher:member_added', (member) => {
        action('ADD_MEMBER', { id: member.id, info: member.info });
      });

      channel.bind('pusher:member_removed', (member) => {
        action('REMOVE_MEMBER', member.id);
      });
    },

    publish: async (channelName, eventName, data) => {
      const channel = pusher.subscribe(channelName);
      channel.trigger(eventName, data);
      setTimeout(() => {
        channel.unbind_all();
        channel.unsubscribe();
      }, 10);
    },

    unsubscribe: (channelName) => {
      pusher.unbind_all();
      pusher.unsubscribe(channelName);

      if (channelName.startsWith('presence-')) {
        action('FLUSH_MEMBERS');
      }
    },

    disconnect: () => {
      pusher.disconnect();
    }
  };
};

export default getClient;
